import { useEffect } from 'react';
import { linkApiEventListener } from '../clients/link-api';
import eventQueue from '../events/queue';
import { addFeatureFlag, incrementCurrentJobStepNumber, setContextValue, } from '../tracking/datadog';
import { getLinkApiTemplateType } from '../LinkApiRouter/utils/link-api-response';
/**
 * Emits `link_api_response` and `link_api_request`.
 * Also handles setting contextual state after a link API response returns.
 * This is helpful for tracking.
 */
export default function useHandleLinkApiResponse() {
    useEffect(function () {
        linkApiEventListener.on('response', function (response) {
            // Handle setting DD context for conversion dashboard tracking.
            // Do this prior to emitting to event queue so that state is set correctly for downstream logs.
            var templateType = getLinkApiTemplateType(response);
            if (templateType === 'edge_native') {
                addFeatureFlag('ff-edge');
                setContextValue({ isEdgeNative: true });
            }
            else if (templateType === 'adp_iframe') {
                addFeatureFlag('ff-adp-direct');
                setContextValue({ isAdpDirect: true });
            }
            incrementCurrentJobStepNumber(response.responseType);
            eventQueue.emit('link_api_response', { response: response });
        });
        linkApiEventListener.on('request', function (request) {
            eventQueue.emit('link_api_request', { params: request });
        });
    }, []);
}
